export const environment = {
  production: false,
  API_URL: process.env.REACT_APP_API_URL,
  HOST: "https://webapp-tw-dev-001.azurewebsites.net/",
  //HOST: 'http://localhost:3000/',
};
